module.exports = __webpack_public_path__ + "img/snosteinskredaktsomhet.e2126386.jpg";